const FLY_URL = import.meta.env.VITE_ELECTRON_APP_PROTOCOL;

export function openFlyApp(url: string, callback?: () => void) {
  const flyUrl = `${FLY_URL}${url}`;

  try {
    // Create a temporary link and click it
    const link = document.createElement('a');
    link.href = flyUrl;
    // Removed target="_blank" to prevent opening new tab
    link.target = '_top';

    // Append to document and click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Set a timeout to check if the protocol worked
    // If the protocol fails, it usually happens asynchronously
    setTimeout(() => {
      // Check if the page is still focused/visible after attempting to open the protocol
      // This is a reasonable heuristic for detecting protocol handler failures
      if (document.hasFocus() && !document.hidden) {
        if (callback) {
          callback();
        }
      }
    }, 3000);
  } catch (error) {
    console.error('Error opening Fly app:', error);
    if (callback) {
      callback();
    }
  }
}
